module.exports = __webpack_public_path__ + "img/58.81ce3f23.jpg";